module.exports = __webpack_public_path__ + "img/fancy_check.38ee3c20.svg";